export const fetcher = {
  async GET(endpoint) {
    const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3821";
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    try {
      const res = await fetch(`${baseUrl}${endpoint}`, {
        method: "GET",
        signal: controller.signal,
        cache: "no-store",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        console.error(
          `[fetcher]: GET ${endpoint} -> ${res.status} ${res.statusText}`,
        );
        return { success: false, message: `Request gagal: ${res.status}` };
      }

      const raw = await res.json();
      return { success: true, message: "Request berhasil.", data: raw };
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === "AbortError") {
        console.error(`[fetcher]: Timeout: ${endpoint} exceeded 5000ms`);
        return { success: false, message: "Request timeout" };
      }

      console.error(`[fetcher]: Network error on ${endpoint}`);
      return { success: false, message: "Terjadi kesalahan pada server." };
    }
  },
};
